import React from 'react';

interface ColumnSubTextProps {
  text: string;
}

const ColumnSubText: React.FC<ColumnSubTextProps> = ({ text }) => {

  return (
    <span style={{
      fontSize: '12px',
      color: '#c8c8c8'
    }}>
      {text}
    </span>
  );
};

export default ColumnSubText;
